import api from "./api";

export const getDashboard = async (company_id: string): Promise<any> => {
    try {
        const token: string | null = localStorage.getItem("token"); // Get token from localStorage

        if (!token) {
            throw new Error("No token found, please log in.");
        }

        const response = await api.get(`/dashboard/v2?company_id=${company_id}`, {
            headers: {
                Authorization: `Bearer ${token}`, // Attach token to headers
            },
        });

        if (response.data.status) {
            return response.data.data;
        } else {
            throw new Error(response.data.message); // Throw error with message
        }
    } catch (error) {
        if (error instanceof Error) {
            throw new Error(error.message || "Unable to get Data");
        } else {
            throw new Error("An unknown error occurred");
        }
    }
};

export const getDashboardData = async (company_id: string): Promise<any> => {
    try {
        const token: string | null = localStorage.getItem("token"); // Get token from localStorage

        if (!token) {
            throw new Error("No token found, please log in.");
        }

        const response = await api.get(`/dashboard/data?company_id=${company_id}`, {
            headers: {
                Authorization: `Bearer ${token}`, // Attach token to headers
            },
        });

        if (response.data.status) {
            return response.data.data;
        } else {
            throw new Error(response.data.message); // Throw error with message
        }
    } catch (error) {
        if (error instanceof Error) {
            throw new Error(error.message || "Unable to get Data");
        } else {
            throw new Error("An unknown error occurred");
        }
    }
};
